import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "../../../../node_modules/swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useDispatch, useSelector } from "react-redux";
import { GetCarTypeMeta } from "../../../Redux/Car";
import { carTypeImageUrl } from "../../../utils";

import { CarBookSearchModel } from "./MeetSomeMoreCar";
import { useTranslation } from "react-i18next";
import { carDetailsNoCar } from "../../Component/ImageList";
import { NoDataYet } from "../../Component/BookingBase";
import BookingIcon from "../../Assets/BookingIcon";

const CarCategories = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { typeList } = useSelector((state) => state.car);

  const [isModalOpen, setIsModelOpen] = useState(false);

  useEffect(() => {
    dispatch(GetCarTypeMeta("type", "typeList", true));
  }, []);

  const cancelHandler = () => {
    setIsModelOpen(false);
    dispatch({ type: "SEARCH_SET", payload: { name: "filterDataCar", value: { type: [] } } });
  };

  const openModal = (id) => {
    setIsModelOpen(true);
    dispatch({ type: "SEARCH_SET", payload: { name: "filterDataCar", value: { type: [id] } } });
  };

  const [windowSize, setWindowSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <>
      <div className="container fleet-overview py-5">
        <h4 className="ff_bd f38 text-center pt-0 carRentalWorkSectionHeading txt-primary mb-2">{t("titles.fleetOverview")}</h4>
        {typeList && (
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination, Navigation]}
            className={`mySwiper ${typeList && typeList?.length <= 9 && windowSize > 1400 ? "item-center" : " "} ${
              typeList && typeList?.length <= 7 && windowSize >= 1024 && windowSize <= 1400 ? "item-center" : " "
            } ${typeList && typeList?.length <= 5 && windowSize >= 767 && windowSize <= 1024 ? "item-center" : " "} ${
              typeList && typeList?.length <= 4 && windowSize >= 320 && windowSize <= 768 ? "item-center" : " "
            }`}
            navigation={true}
            breakpoints={{
              320: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 5,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 7,
                spaceBetween: 25,
              },
              1400: {
                slidesPerView: 9,
                spaceBetween: 25,
              },
            }}
          >
            {typeList &&
              typeList.map((item, index) => {
                return (
                  <SwiperSlide key={index}>
                    <div
                      className="p-2 d-flex align-items-center justify-content-center flex-column"
                      onClick={() => {
                        openModal(item?._id);
                      }}
                    >
                      {item?.image ? (
                        <img
                          src={`${carTypeImageUrl}/${item?.image}`}
                          style={{ objectFit: "contain", maxWidth: "100px", height: "100px" }}
                          onError={(event) => (event.target.src = carDetailsNoCar)}
                          alt="cartype"
                        />
                      ) : (
                        <img src={carDetailsNoCar} style={{ objectFit: "contain", maxWidth: "100px", height: "100px" }} alt="cartype" />
                      )}
                      <h4 className="text-center mt-3 ff_md f14 txt-primary">{item?.type}</h4>
                    </div>
                  </SwiperSlide>
                );
              })}
          </Swiper>
        )}

        {typeList && typeList?.length === 0 && <NoDataYet svg={BookingIcon?.NoDataFound} description={"No fleet overview added yet"} className={""} className2={"pt-5"} />}
      </div>
      <CarBookSearchModel isOpen={isModalOpen} cancelHandler={cancelHandler} carIndex={null} modalUID={"is1"} />
    </>
  );
};

export default CarCategories;
